import { component } from 'picoapp'
import '@/lib/jquery-global.js';
import 'isotope-layout/dist/isotope.pkgd.min.js'
import { addVariant, addItemById } from '@/lib/cart.js'
// import * as cart from '@shopify/theme-cart';

export default component((node, ctx) => {


  
    let grid = $('.colls').isotope({
        // options
        layoutMode: 'fitRows'
    });

      // filter items on button click
    $('.coll-tag').on( 'click', function() {
        $('.coll-tag').removeClass('active')
        $(this).toggleClass('active')
        var filterValue = $(this).attr('data-filter');
        grid.isotope({ filter: filterValue });
        location.hash = 'filter=' + encodeURIComponent( filterValue );
    });

    jQuery('.js-quick-add').click(async function() {
        let id = jQuery(this).data('id')

        addItemById(id, 1)
    })

    function getHashFilter() {
        var hash = location.hash;
        // get filter=filterName
        var matches = location.hash.match( /filter=([^&]+)/i );
        var hashFilter = matches && matches[1];
        return hashFilter && decodeURIComponent( hashFilter );
    }
    
    
    function onHashchange() {
        var hashFilter = getHashFilter();

        if ( !hashFilter ) {
            return;
        }
        
        
        // filter isotope
        grid.isotope({
            itemSelector: '.coll-item',
            layoutMode: 'fitRows',
            filter: hashFilter
        });
        // set selected class on button
        if ( hashFilter ) {
            $('.coll-tag').removeClass('active')
            jQuery('[data-filter="' + hashFilter + '"]').addClass('active');
        }
    }
    
    $(window).on( 'hashchange', onHashchange );
    // trigger event handler to init Isotope
    onHashchange();
    
    
})
